function voicePrompt(text) {
  const t = String(text || "").trim();
  if (!t) return;
  new Audio(
    "https://tts.baidu.com/text2audio?lan=zh&ie=UTF-8&spd=5&text=" +
      encodeURIComponent(t)
  ).play();
}
 
export { voicePrompt };
 
